import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
let title = ' - 枫叶林'
const routes = [
    {
        path: '/',
        name: 'Index',
        component: (resolve) => require(['../views/index/index.vue'], resolve),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/location',
        name: 'Location',
        component: (resolve) => require(['../views/index/location.vue'], resolve),
        meta: {
            title: '自提点选择'
        }
    },
    {
        path: '/search/index',
        name: 'Search',
        component: (resolve) => require(/* 搜索 */ ['../views/search/index.vue'], resolve),
        meta: {
            title: '商品搜索'
        }
    },
    {
        path: '/search/list',
        name: 'SearchList',
        component: (resolve) => require(/* 搜索结果 */ ['../views/search/list.vue'], resolve),
        meta: {
            title: '搜索结果'
        }
    },
    {
        path: '/goods/category',
        name: 'GoodsCategory',
        component: (resolve) => require(/* 商品分类 */ ['../views/goods/category.vue'], resolve),
        meta: {
            title: '商品分类'
        }
    },
    {
        path: '/goods/list',
        name: 'GoodsList',
        component: (resolve) => require(/* 商品列表 */ ['../views/goods/list.vue'], resolve),
        meta: {
            title: '商品列表'
        }
    },
    {
        path: '/goods/seckill',
        name: 'GoodsSeckill',
        component: (resolve) => require(/* 秒杀产品详情 */ ['../views/goods/seckill.vue'], resolve),
        meta: {
            title: '秒杀商品详情'
        }
    },
    {
        path: '/goods/show',
        name: 'GoodsShow',
        component: (resolve) => require(/* 产品详情 */ ['../views/goods/show.vue'], resolve),
        meta: {
            title: '商品详情'
        }
    },
    {
        path: '/goods/common',
        name: 'GoodsCommon',
        component: (resolve) => require(/* 产品详情 */ ['../views/goods/common.vue'], resolve),
        meta: {
            title: '商品评价列表'
        }
    },
    {
        path: '/order/cart',
        name: 'Cart',
        component: (resolve) => require(/* 购物车 */ ['../views/order/cart.vue'], resolve),
        meta: {
            title: '购物车'
        }
    },
    {
        path: '/order/coupon',
        name: 'OrderCoupon',
        component: (resolve) => require(/* 优惠中心 */ ['../views/order/coupon.vue'], resolve),
        meta: {
            title: '领劵中心'
        }
    },
    {
        path: '/flow/checkout',
        name: 'checkout',
        component: (resolve) => require(/* 订单提交 */ ['../views/flow/checkout.vue'], resolve),
        meta: {
            title: '订单提交'
        }
    },
    {
        path: '/order/map',
        name: 'Map',
        component: (resolve) => require(/* 订单提交 */ ['../views/order/map.vue'], resolve),
        meta: {
            title: '查看地图'
        }
    },
    {
        path: '/login/login',
        name: 'Login',
        component: (resolve) => require(/* 会员中心 */ ['../views/login/login.vue'], resolve),
        meta: {
            title: '用户登录'
        }
    },
    {
        path: '/login/register',
        name: 'Register',
        component: (resolve) => require(/* 会员中心 */ ['../views/login/register.vue'], resolve),
        meta: {
            title: '用户注册'
        }
    },
    {
        path: '/login/acc_paw',
        name: 'AccPaw',
        component: (resolve) => require(/* 会员中心 */ ['../views/login/acc_paw.vue'], resolve),
        meta: {
            title: '忘记密码'
        }
    },
    {
        path: '/login/wechat',
        name: 'Wechat',
        component: (resolve) => require(/* 会员中心 */ ['../views/login/wechat.vue'], resolve),
        meta: {
            title: '已有小程序账户'
        }
    },
    {
        path: '/member',
        name: 'Member',
        component: (resolve) => require(/* 会员中心 */ ['../views/member/member.vue'], resolve),
        meta: {
            title: '会员中心'
        }
    },
    {
        path: '/member/address',
        name: 'MemberAddress',
        component: (resolve) => require(/* 我的地址 */ ['../views/member/address.vue'], resolve),
        meta: {
            title: '我的地址'
        }
    },
    {
        path: '/member/add_address',
        name: 'MemberAddAddress',
        component: (resolve) => require(/* 添加地址 */ ['../views/member/add_address.vue'], resolve),
        meta: {
            title: '添加地址'
        }
    },
    {
        path: '/member/edit_userinfo',
        name: 'EditUserInfo',
        component: (resolve) => require(/* 添加地址 */ ['../views/member/edit_userinfo.vue'], resolve),
        meta: {
            title: '用户信息修改'
        }
    },
    {
        path: '/member/edit_address',
        name: 'MemberEditAddress',
        component: (resolve) => require(/* 添加地址 */ ['../views/member/edit_address.vue'], resolve),
        meta: {
            title: '修改地址'
        }
    },
    {
        path: '/member/bonus',
        name: 'MemberBonus',
        component: (resolve) => require(/* 我的积分 */ ['../views/member/bonus.vue'], resolve),
        meta: {
            title: '我的积分'
        }
    },
    {
        path: '/member/contact',
        name: 'MemberContact',
        component: (resolve) => require(/* 客服中心 */ ['../views/member/contact.vue'], resolve),
        meta: {
            title: '客服中心'
        }
    },
    {
        path: '/member/coupon',
        name: 'MemberCoupon',
        component: (resolve) => require(/* 优惠券 */ ['../views/member/coupon.vue'], resolve),
        meta: {
            title: '我的优惠券'
        }
    },
    {
        path: '/member/promo_code',
        name: 'PromoCode',
        component: (resolve) => require(/* 优惠券 */ ['../views/member/promo_code.vue'], resolve),
        meta: {
            title: '我的兑换码'
        }
    },
    {
        path: '/member/faq',
        name: 'MemberFaq',
        component: (resolve) => require(/* 常见问题 */ ['../views/member/faq.vue'], resolve),
        meta: {
            title: '常见问题'
        }
    },
    {
        path: '/member/collect',
        name: 'MemberFavor',
        component: (resolve) => require(/* 我的收藏 */ ['../views/member/collect.vue'], resolve),
        meta: {
            title: '我的收藏'
        }
    },
    {
        path: '/member/order',
        name: 'MemberOrder',
        component: (resolve) => require(/* 我的订单 */ ['../views/member/order.vue'], resolve),
        meta: {
            title: '我的订单'
        }
    }, {
        path: '/member/order_show',
        name: 'MemberOrderShow',
        component: (resolve) => require(/* 我的订单详情 */ ['../views/member/order_show.vue'], resolve),
        meta: {
            title: '订单详情'
        }
    },
    {
        path: '/member/return_goods',
        name: 'MemberReturnGoods',
        component: (resolve) => require(/* 售后退款 */ ['../views/member/return_goods.vue'], resolve),
        meta: {
            title: '售后退款'
        }
    },
    {
        path: '/order/express',
        name: 'OrderExpress',
        component: (resolve) => require(/* 售后退款 */ ['../views/order/express.vue'], resolve),
        meta: {
            title: '查看物流详情'
        }
    },
    {
        path: '/order/common',
        name: 'OrderCommon',
        component: (resolve) => require(/* 售后退款 */ ['../views/order/common.vue'], resolve),
        meta: {
            title: '订单商品评价'
        }
    },
    {
        path: '/order/refund/index',
        name: 'OrderRefundIndex',
        component: (resolve) => require(/* 售后退款 */ ['../views/order/refund/index.vue'], resolve),
        meta: {
            title: '售后服务'
        }
    },
    {
        path: '/order/refund/detail',
        name: 'OrderRefundDetail',
        component: (resolve) => require(/* 售后退款 */ ['../views/order/refund/detail.vue'], resolve),
        meta: {
            title: '售后详情'
        }
    },
    {
        path: '/_select/index',
        name: 'SelectIndex',
        component: (resolve) => require(/* 选择自提门店 */ ['../views/_select/index.vue'], resolve),
        meta: {
            title: '选择自提门店'
        }
    },
    {
        path: '/shop/detail',
        name: 'ShopDetail',
        component: (resolve) => require(/* 门店详情 */ ['../views/shop/detail.vue'], resolve),
        meta: {
            title: '门店详情'
        }
    },
    {
        path: '/article/detail',
        name: 'ArticleDetail',
        component: (resolve) => require(/* 文章详情 */ ['../views/article/detail.vue'], resolve),
        meta: {
            title: '资讯详情'
        }
    },
    {
        path: '/goods/supper',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/goods/supper.vue'], resolve),
        meta: {
            title: '资讯详情'
        }
    },
    {
        path: '/goods/bargain',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/goods/bargain.vue'], resolve),
        meta: {
            title: '砍价专区'
        }
    },
    {
        path: '/goods/bargain_details',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/goods/bargain_details.vue'], resolve),
        meta: {
            title: '参与砍价'
        }
    },
    {
        path: '/dealer/index',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/dealer/index/index.vue'], resolve),
        meta: {
            title: '分销中心'
        }
    },
    {
        path: '/dealer/apply',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/dealer/apply/apply.vue'], resolve),
        meta: {
            title: '申请成为分销商'
        }
    },
    {
        path: '/coupon/coupon',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/coupon/coupon.vue'], resolve),
        meta: {
            title: '领券中心'
        }
    },
    {
        path: '/withdraw/apply',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/withdraw/apply/apply.vue'], resolve),
        meta: {
            title: '申请提现'
        }
    },
    {
        path: '/withdraw/list',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/withdraw/list/list.vue'], resolve),
        meta: {
            title: '提现明细'
        }
    },
    {
        path: '/dealer/order',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/dealer/order/order.vue'], resolve),
        meta: {
            title: '分销订单'
        }
    },
    {
        path: '/dealer/team',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/dealer/team/team.vue'], resolve),
        meta: {
            title: '我的团队'
        }
    },
    {
        path: '/clause/clause',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/clause/clause.vue'], resolve),
        meta: {
            title: '使用条款'
        }
    },
    {
        path: '/clause/returning',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/clause/returning.vue'], resolve),
        meta: {
            title: '退货条款'
        }
    },
    {
        path: '/clause/paymentmethod',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/clause/paymentmethod.vue'], resolve),
        meta: {
            title: '支付方式'
        }
    },
    {
        path: '/clause/privacy_policy',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/clause/privacy_policy.vue'], resolve),
        meta: {
            title: '支付方式'
        }
    },
    {
        path: '/clause/mailing_information',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/clause/mailing_information.vue'], resolve),
        meta: {
            title: '邮寄信息'
        }
    },
    {
        path: '/clause/terms_of_use',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/clause/terms_of_use.vue'], resolve),
        meta: {
            title: '邮寄信息'
        }
    },
    {
        path: '/member/card/list',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/member/card/list.vue'], resolve),
        meta: {
            title: '我的信用卡'
        }
    },
    {
        path: '/member/card/add',
        name: 'supper',
        component: (resolve) => require(/* 文章详情 */ ['../views/member/card/add.vue'], resolve),
        meta: {
            title: '添加信用卡'
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
